// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"link-boxes-component_uk-open__FOxGW","grecaptcha-badge":"link-boxes-component_grecaptcha-badge__s4wpl","outerWrapper":"link-boxes-component_outerWrapper__lvKwL","innerWrapper":"link-boxes-component_innerWrapper__16I0m","linkBox":"link-boxes-component_linkBox__AjrnW"};
    if(module.hot) {
      // 1793877036389
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  